import * as React from 'react';

type Props = {
  hasPost: boolean,
  hasConsent: boolean,
  postUrl?: string
} & React.HTMLAttributes<HTMLElement>;

// has to switch from link to div in the case of consent placeholder, otherwise we have nested <a> tags
const ImageTileWrapper = ({ hasPost, hasConsent, postUrl, ...restProps }: Props): JSX.Element => {
  if (hasConsent) {
    return (
      <a
        href={hasPost && postUrl || undefined}
        target="_blank"
        rel="noopener noreferrer"
        {...restProps}
      >
        {restProps.children}
      </a>
    );
  }

  return (
    <div {...restProps}>
      {restProps.children}
    </div>
  );
};

export default ImageTileWrapper;
